// components/news.js
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";

export default function News({ websiteId, section, basePath }) {
  const [items, setItems] = useState([]);
  const [state, setState] = useState({ loading: true, error: null });

  useEffect(() => {
    (async () => {
      try {
        const data = await api.itemsBySection(section._id);
        // newest first already (sorted by updatedAt desc on server)
        setItems(data || []);
        setState({ loading: false, error: null });
      } catch (e) {
        setState({ loading: false, error: e.message || "Network error" });
      }
    })();
  }, [section?._id]);

  if (state.loading) return <div className="p-8">Laddar nyheter…</div>;
  if (state.error) return <div className="p-8 text-red-600">Fel: {state.error}</div>;

  return (
    <section className="p-8 min-h-[50vh] w-fit mx-auto lg:pb-16 lg:px-48 portrait:min-h-[57vh]">
      <h2 className="text-2xl font-bold mb-4">{section?.name || "Nyheter"}</h2>
      <ul className="space-y-4">
        {items.map((item) => (
          <li key={item._id} className="border-b pb-4">
            <Link to={`${basePath}/nyheter/${item.link}`} className="block">
              <h3 className="font-semibold text-lg">{item.name}</h3>
              <p className="text-sm text-gray-600">
                Uppdaterad: {new Date(item.updatedAt).toLocaleDateString("sv-SE")}
              </p>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
